export default class PressNewsOverviewPage {
	static init() {
		let searchField = document.getElementById('press-news-overview-page__search');
		if (!searchField) return;
		searchField.addEventListener('change', (e) => {
			e.target.closest('form').submit();
		});
	}
}
